import { FC } from 'react';

export const IconTime: FC = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg fill="none" height="40" width="40" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip1)">
      <path
        clipRule="evenodd"
        d="M1.338 24.066l1.708-1.709A18.51 18.51 0 1021.542 1.49h-.136c-.256.002-.511.01-.766.022l.098 1.997c.248-.012.497-.018.746-.02A16.511 16.511 0 115.03 22.1l1.965 1.965 1.414-1.414-3.535-3.535-.708-.707-.707.707-3.535 3.535 1.414 1.415zm3.855-6.072c.101-.6.23-1.207.38-1.8l-1.94-.489a25.37 25.37 0 00-.412 1.954l1.972.335zm.901-3.554a15.497 15.497 0 01.645-1.577l-1.808-.855a17.544 17.544 0 00-.726 1.775l1.89.657zm1.402-2.994c.276-.46.574-.905.893-1.336L6.783 8.919c-.359.483-.693.983-1.002 1.499l1.715 1.028zM9.41 8.868a16.36 16.36 0 011.136-1.136L9.202 6.25a18.378 18.378 0 00-1.275 1.275l1.482 1.343zm2.378-2.156c.43-.32.877-.617 1.336-.893l-1.028-1.715c-.516.309-1.016.643-1.5 1.002l1.192 1.606zm2.753-1.65a16.404 16.404 0 011.485-.615l-.674-1.883a18.382 18.382 0 00-1.666.69l.855 1.808zm3.023-1.082c.52-.13 1.046-.235 1.576-.313l-.293-1.979c-.596.089-1.186.206-1.77.352l.487 1.94zM20 8v12.533l.442.297 8.375 5.625 1.116-1.66L22 19.467V8h-2z"
        fill="#737A8E"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip1">
        <path d="M0 0h40v40H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

IconTime.displayName = 'IconTime';
